var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-list-group-item",
    [
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between mb-1",
          on: {
            click: function($event) {
              _vm.isInModal && _vm.selectAllOrders(_vm.delivery.orders)
            }
          }
        },
        [
          _c("span", [_vm._v("№ " + _vm._s(_vm.delivery.id))]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.delivery.status.name))])
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.delivery.orders, function(ord) {
        return _c(
          "b-list-group-item",
          {
            key: ord.id,
            staticClass: "orderInDelivery",
            class: {
              activeIt:
                _vm.isInModal &&
                _vm.selectedOrders &&
                _vm.selectedOrders.includes(ord.id)
            },
            on: {
              click: function($event) {
                _vm.isInModal && _vm.selectOrder(ord)
              }
            }
          },
          [
            _c("order-block", {
              attrs: {
                type: "delivery-list-all",
                order: ord,
                "order-stages": _vm.orderStages
              }
            })
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.CAA === false &&
      (_vm.delivery.status.keyword === _vm.STATUS_DELIVERY.NEW ||
        _vm.delivery.status.keyword === _vm.STATUS_DELIVERY.CHOSEN_COURIER) &&
      _vm.isSuperLogistician
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-between" },
            [
              _c(
                "b-button",
                {
                  staticClass: "px-2 py-0 pb-1 flex-grow-1",
                  attrs: { variant: "danger" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.$emit("disband-delivery", _vm.delivery)
                    }
                  }
                },
                [_c("icon", { attrs: { name: "trash-alt" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "px-2 py-0 pb-1 flex-grow-1",
                  attrs: {
                    disabled: _vm.numberSelectedOrders === 0,
                    variant: "success"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.$emit("add-order-to-delivery", _vm.delivery)
                    }
                  }
                },
                [_c("icon", { attrs: { name: "plus" } })],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showCourier &&
      _vm.delivery.status.keyword !== _vm.STATUS_DELIVERY.END &&
      _vm.isSuperLogistician
        ? _c(
            "b-form-group",
            {
              staticClass: "mb-0 mt-0",
              attrs: { "label-size": "sm", label: "Курьер:" }
            },
            [
              _c("b-form-select", {
                attrs: { options: _vm.couriersOptions },
                on: { change: _vm.changeCourier },
                model: {
                  value: _vm.selectedCourier,
                  callback: function($$v) {
                    _vm.selectedCourier = $$v
                  },
                  expression: "selectedCourier"
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76bd99d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76bd99d7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeliveryItem.vue
// module id = null
// module chunks = 